import { Flex, Grid, Splitter } from 'antd';

import { DirectoryTreeWrapper } from './directory-tree-wrapper';
import { DocumentTable } from './document-table';

export const DocumentsPageLayout = () => {
    const screens = Grid.useBreakpoint();
    const isMobile = !screens.md;

    if (isMobile) {
        return (
            <Flex style={{ height: '100%', width: '100%', overflow: 'hidden' }}>
                <Splitter layout="vertical" style={{ height: '100%' }}>
                    <Splitter.Panel
                        defaultSize="22%"
                        min="10%"
                        max="50%"
                        style={{
                            padding: '2px 4px 4px 4px',
                            borderBottom: '1px solid #f0f0f0',
                            overflow: 'hidden',
                        }}
                    >
                        <div style={{ height: '100%', overflow: 'auto' }}>
                            <DirectoryTreeWrapper />
                        </div>
                    </Splitter.Panel>
                    <Splitter.Panel style={{ padding: '4px 4px 0px 4px', overflow: 'hidden' }}>
                        <div style={{ height: '100%', overflow: 'hidden' }}>
                            <DocumentTable />
                        </div>
                    </Splitter.Panel>
                </Splitter>
            </Flex>
        );
    }

    return (
        <Flex style={{ height: '100%', width: '100%', overflow: 'hidden' }}>
            <Splitter style={{ height: '100%' }}>
                <Splitter.Panel
                    defaultSize="20%"
                    min="10%"
                    max="40%"
                    style={{
                        padding: '8px',
                        borderRight: '1px solid #f0f0f0',
                        overflow: 'hidden',
                    }}
                >
                    <div style={{ height: '100%', overflow: 'auto' }}>
                        <DirectoryTreeWrapper />
                    </div>
                </Splitter.Panel>
                <Splitter.Panel
                    style={{
                        padding: '8px 8px 0px 16px',
                        overflow: 'hidden',
                    }}
                >
                    <div style={{ height: '100%', overflow: 'hidden' }}>
                        <DocumentTable />
                    </div>
                </Splitter.Panel>
            </Splitter>
        </Flex>
    );
};
